<template>
  <page-outline :title="$t('Webheader.history')">
    <template slot="pageContent">
    <!-- <div class="layoutTop"></div> -->
      <div class="listPage overflow-hidden">
        <b-row>
          <b-col>
            <div class="requestsList">
              <f7-list class="mb-2">
                <f7-list-item :class="additionalClass">
                  <b-row class="no-gutter justify-content-start">
                    <!-- Left section filtre -->
                    <b-button class="btn btnFilter btn-secondary"
                      @click="refreshInbox()">
                      <i class="fa-light fa-rotate-right"></i>
                    </b-button>
                    <!-- Right section filtre -->
                    <!-- <b-button class="btn btnFilter_2 ml-2"
                      @click="exportList()">
                      <i class="fa-light fa-upload"></i>
                      <span class="fab-label">{{ $t('common.extract_list') }}</span>
                    </b-button> -->
                    <!-- TLV 15/01/2021 - Button for showing the filter on small screens more clearly -->
                  </b-row>
                </f7-list-item>

                    <!-- Sélection des valeurs de Filtre -->
                <f7-list-item class="filter-item-section showLargeScreenOnly">
                  <b-row class="min-w-100">
                    <b-col class="d-flex flex-row">
                      <!-- Filtre date de début -->
                      <div class="filter-item">
                        <span class="filter-item-title text-ellipsis" :title="$t('common.date_start_label')">
                          {{ $t('common.date_start_label') }}
                        </span>
                        <span class="filter-item-content">
                          <form-write-group-label-input
                          inputIcon="fa-solid fa-calendar text-info"
                          v-model="dateBegin"
                          inputType="datetime" disablePastDates
                          labelClass=""
                          class="z-0"
                          :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin}">
                          </form-write-group-label-input>
                        </span>
                      </div>
                      <!-- Filtre date de fin -->
                      <div class="filter-item">
                        <span class="filter-item-title text-ellipsis" :title="$t('common.date_end_label')">
                          {{ $t('common.date_end_label') }}
                        </span>
                        <span class="filter-item-content">
                          <form-write-group-label-input
                          inputIcon="fa-solid fa-calendar text-info"
                          v-model="dateEnd"
                          :colLabelSize="4"
                          :colInputSize="8"
                          inputType="datetime" disablePastDates
                          inputClass=" w-100"
                          labelClass=""
                          class="z-1"
                          :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd}">
                          </form-write-group-label-input>
                        </span>
                      </div>
                      <!--Filtre actionType -->
                      <div class="filter-item">
                        <span class="filter-item-title">{{ $t('common.action_type') }}</span>
                        <span class="filter-item-content">
                          <select id="select-action-type" v-model="actionType" class="pt-1 z-2 h-auto cursor fs-14px-important">
                            <option value="">{{ $t('history.slct_actn') }}</option>
                            <option v-for="(label, type) in actionList" :key="type" :value="type" :title="label">{{ label }}</option>
                          </select>
                          <i class="fa-light fa-chevron-down p-1 z-1 float-right cursor mt--22px-important" ref="select-action-type">
                          </i>
                        </span>
                      </div>
                      <!-- Filtre user -->
                      <div class="filter-item">
                        <span class="filter-item-title">{{ $t('common.user') }}</span>
                        <span class="filter-item-content">
                          <input v-model="user"
                            type="text"
                            :class="{'filter-item-input': true, 'filter-item-input-complete': user}"
                            :placeholder="$t('common.user')">
                          </input>
                        </span>
                      </div>
                    </b-col>
                    <!-- Bouton Effacer et Appliquer -->
                    <b-col cols="3" class="d-flex mt-4">
                      <b-button class="btn mr-2" size="sm"
                        @click="clearFilterFields"
                        :disabled="!hasInputFilter">
                        {{ $t('filter.clr_fltr_field') }}
                      </b-button>
                      <b-button class="btn" size="sm"
                        @click="applyFilter">
                        {{ $t('filter.fltr') }}
                      </b-button>
                    </b-col>
                  </b-row>
                </f7-list-item>
              </f7-list>

              <spinner v-if="activateSpinner"></spinner>
              <div v-else>
                <b-table hover borderless outlined class="table mt-3 text-center"
                  v-if="inboxMessages.length"
                  :items="inboxMessages"
                  :fields="historyFields">
                  <template #cell(dateAction)="data"><div class="cursor text-ellipsis"><span :title="data.value">{{data.value | formatDateTime}}</span></div></template>
                </b-table>
                <div class="d-flex justify-content-center mt-5" v-else><b>{{ $t('common.no_result')}}</b></div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="!activateSpinner" class="mt-1">
          <b-col cols="12">
            <cm-pagination :maxResultsByPage="paginationObject.maxResults" :firstIndex="paginationObject.firstIndex" :nbResultsTotal="paginationObject.nbResultsTotal" :refreshEvent="paginationObject.refresh"></cm-pagination>
          </b-col>
        </b-row>
      </div>
  <!-- </f7-page> -->
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'

import { errorMessageAlert } from '@/helpers/alert'
import { formatDateTime } from '@/helpers/format'

export default {
  name: 'Inbox',
  components: {
    'cm-pagination': Pagination,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'spinner': Spinner,
    'page-outline': PageOutline
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    direction: {
      default: '2',
      type: String
    }
  },
  computed: {
    actionList () {
      return {
        1: this.$i18n.t('history.action_type.1'),
        2: this.$i18n.t('history.action_type.2'),
        3: this.$i18n.t('history.action_type.3'),
        4: this.$i18n.t('history.action_type.4'),
        5: this.$i18n.t('history.action_type.5'),
        6: this.$i18n.t('history.action_type.6'),
        7: this.$i18n.t('history.action_type.7')
      }
    },
    appLanguage () {
      return this.$i18n.locale
    },
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    hasAdminHistoryConsulter() {
      return this.$engine.rights.rightIs('history_consulter_admin', true)
    },
    historyFields () {
      let fields = [
        { key: 'dateAction', label: this.$t('common.date_label'), class: 'text-center col-3' },
        { key: 'account', label: this.$t('administration.company'), class: 'text-center col-3'},
        { key: 'login', label: this.$t('common.usr'), class: 'text-center col-3' },
        { key: 'label', label: this.$t('common.action_label'), class: 'text-center col-3' }
      ]
      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    hasInputFilter () {
      if (
        this.dateBegin ||
        this.dateEnd ||
        this.endToEndId ||
        this.actionType ||
        this.user) {
        return true
      }
      return false
    }
  },
  data () {
    return {
      activateSpinner: false,
      filterBy: '',
      dateBegin: '',
      dateEnd: '',
      actionType: '',
      user: '',
      inboxMessages: [],
      completeList: [],
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      serviceId : this.$engine.user.currentService.id.toString(),
      sortDirection: 'DESC',
      sortField: 'dateAction',
      displayFilter: false,
      hasDefaultFilter: false,
      reload: false
    }
  },
  created () {
    this.reload = false
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Historique',
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0

    this.mode = parseInt(this.modeFilter, 10)
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'history-page'
    this.$bus.$off('history-page')
    this.$bus.$on('history-page', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
    // this.filterTypeGet = this.filterType
    // this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
  },
  beforeDestroy () {
    let that = this
    that.$engine.history.cleanFilterCondition()
  },
  methods: {
    applyFilter () {
      let filterConditions = {}
      this.reload = true

      filterConditions.dateBegin = formatDateTime(this.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.dateEnd)
      filterConditions.login = this.user
      filterConditions.typeAction = this.actionType

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      let that = this
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = 'DESC' //this.sortDirection

      this.activateSpinner = true
      this.$engine.history.update(
        this.direction,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults //actionHistory.length
        that.paginationObject.nbResults = resp.data.actionHistory.length
        requests = resp.data.actionHistory
        // requests = requests.slice(that.paginationObject.firstIndex - 1, that.paginationObject.firstIndex - 1 + that.paginationObject.maxResults)
        that.updateInbox(requests)
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.dateBegin = ''
      this.dateEnd = ''
      this.endToEndId = ''
      this.actionType = ''
      this.user = ''
      this.communicateChange()
      this.applyFilter()
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        // this.$$('.infinite-scroll').append(
        // '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        // )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    exportList () {
      // mettre en place mode CSV coté modé
      let that = this
      let filterConditions = {}

      filterConditions.dateBegin = formatDateTime(this.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.dateEnd)
      filterConditions.user = this.user
      filterConditions.typeAction = this.actionType

      this.$engine.history.getExport(
        filterConditions
      ).then( resp => {
        let list = {}
        list = resp.data.ExportActionHistory
        that.updateList(list)
        that.exportHistory()
      }).catch(e => {
        errorMessageAlert(e, that)
      })
    },
    exportHistory () {
      this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
      let firstLine = 'Date' + ';' +
        'Type d\'action' + ';' +
        'Utilisateur' + ';' +
        'Identifiant' + ';' +
        'Détails' + '\r\n'

      let line = atob(this.completeList.result)
      let data = firstLine + line
      this.$f7.hidePreloader()
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = 'history_' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onRefresh (noAttach = false, index = 1) {
      // let that = this
      let that = this
      this.pageCounter = 0
      // this.scrollFlag = true
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions = {}

      filterConditions.dateBegin = formatDateTime(this.dateBegin)
      filterConditions.dateEnd = formatDateTime(this.dateEnd)
      filterConditions.user = this.user
      filterConditions.typeAction = this.actionType

      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      filterConditions.lang = this.$i18n.locale.toUpperCase()

      this.$engine.history.update(
        this.direction,
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = []
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.actionHistory.length
        requests = resp.data.actionHistory
        that.updateInbox(requests, noAttach)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    refreshInbox () {
      this.reload = true
      this.onRefresh(false, this.paginationObject['firstIndex'])
    },
    updateInbox (requests, noAttach = false) {
      this.inboxMessages = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    updateList (requests) {
      this.completeList = requests
    },
    showButtonImportLot () {
      // Service RTP import lot identifiant?
      return false
    }
  },
  watch:  {
    appLanguage(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.onRefresh(false)
      }
    }
  }
}
</script>
